import { ResponsivePie } from '@nivo/pie';
import { Paper, Grid, Container, } from '@material-ui/core';


export default function GraficoMinutos({ bodyEmp }) {
    const data = bodyEmp
        .sort((a, b) => {
          return (b.value || 0) - (a.value || 0);
        })
        .map((item) => {
          return {
            ...item,
            id: `${item.name} (${item.value})`,
            label: `${item.name} (${item.value})`,
          };
        });


    return (
        <Grid item xs={12}>
            <Container
              maxWidth="xl"
              component={Paper}
              style={{ height: '870px', width: '100%' }}
            >
              <br />
              <cite>
                Atualmente temos <strong>{data.length}</strong> empresas ativas
              </cite>
              <br />

              <ResponsivePie
                data={data}
                margin={{ top: 15, right: 30, bottom: 190, left: 50 }}
                startAngle={-180}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                sortByValue
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsDiagonalLength={12}
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: 'color' }}
                enableArcLabels={false}
                legends={[
                  {
                    anchor: 'top-right',
                    direction: 'column',
                    justify: false,
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 120,
                    itemHeight: 15,
                    itemsSpacing: 0,
                    symbolSize: 13,
                    itemDirection: 'left-to-right',
                  },
                ]}
              />
            </Container>
          </Grid>
    );
}